const whatsappSupport = (handleClose) => {
  return (
    <a
      href="https://wa.link/hfyruo"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClose}
      style={{ color: '#4c5efe', fontWeight: 'bold', textDecoration: 'underline' }}
    >
      Contactanos
    </a>
  )
}

const ONBOARDING_MODALS = {
  0: {
    key: 'day1',
    title: '¡Bienvenido a Calu! Ya podés agendar tu primer turno 🚀',
    content: (handleClose) => (
      <div>
        <p>Bonus: probá enviar recordatorios por WhatsApp con un solo clic.</p>
        <p>¿Sabías que podés reducir los ausentismos hasta un 70%? </p>

        <a
          href="https://citas.calu.app/preguntas-frecuentes"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClose}
          style={{ color: '#4c5efe', fontWeight: 'bold', textDecoration: 'underline' }}
        >
          ➡️ Accedé a esta guía rápida para revolver todas tus dudas
        </a>
      </div>
    ),
  },
  2: {
    key: 'day2',
    title: '¿Ya personalizaste tu sitio web de turnos?',
    content: (handleClose) => (
      <div>
        <p>Tus pacientes o clientes pueden reservar un turno sin demoras ni confusiones</p>
        <p>📺 Mirá este video tutorial:</p>
        <a
          href="https://www.youtube.com/watch?v=pyw6F5fENZU"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClose}
          style={{ color: '#4c5efe', fontWeight: 'bold', textDecoration: 'underline' }}
        >
          Cómo personalizar tu sitio web de turnos en Calu
        </a>
      </div>
    ),
  },

  3: {
    key: 'day3',
    title: '¿Sabías que podés pedir una seña al reservar?',
    content: (handleClose) => (
      <div>
        <p>
          💸 Con Mercado Pago integrado, reducís los turnos perdidos y <strong>NO PERDÉS DINERO</strong>.
        </p>
        <p>¿Cómo hacerlo? 📺 Mirá este video tutorial:</p>
        <a
          href="https://www.youtube.com/watch?v=uiVcvlXFmWo"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClose}
          style={{ color: '#4c5efe', fontWeight: 'bold', textDecoration: 'underline' }}
        >
          Configuración del pago anticipado para reservar un turno
        </a>
      </div>
    ),
  },

  5: {
    key: 'day5',
    title: 'Tu cuenta está automatizando tareas por vos',
    content: (handleClose) => (
      <div>
        <p>
          <strong>¿Querés seguir así?</strong>
        </p>
        <p>🎯 Organizate con Calu sin perder lo que ya hiciste.</p>

        <p>👉 Hablá con un asesor {whatsappSupport(handleClose)}</p>
      </div>
    ),
  },

  6: {
    key: 'day6',
    title: '¡Tu equipo también puede usar Calu!',
    content: (handleClose) => (
      <div>
        <p>👩‍⚕️ Sumá asistentes o profesionales con acceso personalizado. Centralizá todo desde tu cuenta.</p>
        <p>📺 Mirá este video tutorial:</p>
        <a
          href="https://www.youtube.com/watch?v=a1excSQCxVs"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClose}
          style={{ color: '#4c5efe', fontWeight: 'bold', textDecoration: 'underline' }}
        >
          Gestión de roles dentro de Calu
        </a>
      </div>
    ),
  },

  7: {
    key: 'day7',
    title: 'Hoy finaliza tu prueba gratuita en Calu 😞',
    content: (handleClose) => (
      <div>
        <p>
          Si querés continuar con todo lo que automatizaste, hablá con un asesor y sumate al plan que mejor se adapta a
          vos 🙌🏼 {whatsappSupport(handleClose)}
        </p>
      </div>
    ),
  },
}

export default ONBOARDING_MODALS
